import _ from 'lodash';
import moment from 'moment-timezone';
import * as types from 'src/store/types';
import request from 'src/utils/request';
import apis from 'src/const/apis';
import {
  AD_TYPE,
  identityTypeMap,
  NORMAL_AD_SOURCES,
  VIDEO_RENDER_OPTIONS,
  nativeAdIdentityTypes,
  NATIVE_AD_ACTION_TYPE,
  identityAvailableStatus,
  VIDEO_ASYNC_RENDER_STATUS,
  VIDEO_ASYNC_RENDER_RENDERING_STATUS,
  VIDEO_ASYNC_RENDER_FILL_ACTION_TYPE,
  ADDITIONAL_CREATIVE_IMAGE_CARD_TEMPLATE_TYPES,
  ADDITIONAL_CREATIVE_ATTACHMENT_EXPERIENCE_TYPES,
  PixeOnlyTracking,
  ADDITIONAL_CREATIVE_ENGAGEMENT_TYPES,
  filterPrecheckResult,
  bcIdentityTypesList,
} from 'src/const/state/creative';

import { ADVANCED_CREATIVE_TYPE, SHOP_LIVE_CTA, SHOP_NOW_CTA } from 'src/const/state/call-to-action';
import { captureError } from 'src/logger/errorLogger';
import tool from 'src/utils/tool';
import { DPA_VIDEO_DISPLAY_MODE_TYPE, BrandSafetyTrackTypeMap } from 'src/const/state/ad';
import { isNewCreativeListWhite, isCreativeHasIdentityWhite } from 'src/const/whiteList';
import * as service from 'src/service';
import {
  getTaskList,
  fileNameCheck,
  getTaskRenderStatus,
  getIsVideoRenderAllComplete,
  getTaskRenderPercentageByStatus,
  getIsAsyncRenderVideoRenderDone,
  fetchVideoRenderResultsByTaskIdsBatch,
  getVideoFullInfoListByVideoRenderResultList,
} from 'src/utils/videoRenderAsync';
// import { ADDITIONAL_CREATIVE_PARAMS } from 'src/store/modules/creative/normal-creative/state';
import { getEngagementCreativeInfo, getAttachmentCreativeInfo } from 'src/service/creative';
import { sendLog } from 'src/logger/customLogger';
import { resetCreativeExtraKey } from './reset-helpers';
import {
  getAdTemplateByType, isAdEmpty, setIdentityData, setIdentityDataList, fillCreativeInfo,
} from './helpers';

const RENDER_STATUS = Object.values(VIDEO_ASYNC_RENDER_RENDERING_STATUS);

const {
  IMAGE_CARD: ADDITION_IMAGE_CARD,
  INSTANT_PAGE: ADDITION_INSTANT_PAGE,
  ENGAGEMENT: ADDITION_ENGAGEMENT, // 这个需要考虑旧样式
} = ADDITIONAL_CREATIVE_ATTACHMENT_EXPERIENCE_TYPES;

const {
  SINGLE_IMAGE, SINGLE_VIDEO, CAROUSEL_IMAGE, CATALOGUE_VIDEO, REAL_TIME_LIVE,
} = AD_TYPE;
const { CREATE_NEW, NATIVE_VIDEO } = NORMAL_AD_SOURCES;
const {
  EGG,
  GESTURE,
} = ADDITIONAL_CREATIVE_ENGAGEMENT_TYPES;

export default {
  /* ----------------------------------------------  单纯的api请求 start   ------------------------------------------------------------*/
  getVideoUploadKey({ commit }) {
    request.get(apis.videoUploadKey).then(({ data }) => {
      commit(types.SET_SHA1_KEY, data.sha1_key);
    });
  },
  uploadVideo(store, data) {
    return request.post(apis.videoUpload, data);
  },
  uploadImageToLibrary(store, data) {
    return request.post(apis.library.image_create, data);
  },
  // 检查素材是否重名
  checkNameExist(store, data) {
    return request.post(apis.library.check_name_exist, data);
  },
  /**
   * 获取自动封面接口：
   * 20 秒内轮询接口，如果请求到封面信息或超过 20s 则请停止请求
   * @param vid 视频 vid
   * @returns {Promise<any>}
   */
  getVideoCovers(store, vid) {
    return new Promise((resolve) => {
      const start = new Date().getTime();
      const interval = setInterval(() => {
        const end = new Date().getTime();
        if (end - start > 20000) {
          clearInterval(interval);
          resolve([]);
        } else {
          request
            .get(apis.videoCovers, {
              video_id: vid,
            })
            .then(({ data }) => {
              const { covers } = data;
              if (covers.length > 0) {
                clearInterval(interval);
                resolve(covers.slice(0, 8));
              }
            })
            .catch(() => { });
        }
      }, 500);
    });
  },
  // 获取创意审核建议
  getCreativeSuggestions(store, id) {
    return request.get(apis.creative.suggestions, { creative_id: id });
  },
  verifyAds(store, data) {
    const risk_info = tool.getRiskInfo();
    return request.post(apis.creative.verify, { ...data, risk_info });
  },
  uploadAds(store, data) {
    const risk_info = {
      cookie_enabled: navigator.cookieEnabled,
      screen_width: window.screen.width,
      screen_height: window.screen.height,
      browser_language: navigator.language,
      browser_platform: navigator.platform,
      browser_name: navigator.appCodeName,
      browser_version: navigator.appVersion,
      browser_online: navigator.onLine,
      timezone_name: moment.tz.guess(),
    };
    const params = { risk_info, ...data };
    params.domain = (params.domain === PixeOnlyTracking || !!params.page_id) ? '' : params.domain;
    return request.post(apis.creative.create, params);
  },
  updateAd(store, data) {
    const risk_info = {
      cookie_enabled: navigator.cookieEnabled,
      screen_width: window.screen.width,
      screen_height: window.screen.height,
      browser_language: navigator.language,
      browser_platform: navigator.platform,
      browser_name: navigator.appCodeName,
      browser_version: navigator.appVersion,
      browser_online: navigator.onLine,
      timezone_name: moment.tz.guess(),
    };
    const params = { risk_info, ...data };
    return request.post(apis.creative.update, params);
  },
  getLeadAdsFormList(store, data) {
    return request.post(apis.creative.leadAdsForm, data);
  },
  getLeadAdsProtocal({ commit }, data) {
    // 处理sonor异味 data命名重复问题
    return request.get(apis.creative.protocalQuery, data).then((res) => {
      const isShow = !res.data.lead_gen_signed;
      commit(types.SET_SHOW_PROTOCOL_TERMS, isShow);
    }).catch((e) => { });
  },
  leadAdsProtocalSign(store, data) {
    return request.post(apis.creative.leadAdsProtocalSign, data);
  },
  getLeadAdsFormDetail(store, data) {
    if (!data || !data.page_id) {
      return;
    }
    return request.get(apis.creative.getLeadAdsFormDetail, data);
  },
  getStorefrontPageDetail(store, data) { // 获取 storefront page 详情
    return request.get(apis.creative.storefrontPageDetail, data);
  },
  getProtocolStatus({ commit }, data) { // 协议查询
    request.get(apis.creative.protocolQuery, data).then(({ data = {} }) => {
      const isShow = !data.is_exist;
      commit(types.SET_SHOW_PROTOCOL_TERMS, isShow);
    }).catch(() => { });
  },
  protocolSign(store, data) { // 协议签署
    return request.post(apis.creative.protocolSign, data);
  },
  async getZefrAuthority({ commit }) { // 协议签署
    await request.get(apis.creative.brandSafetyAuthority, { partner: BrandSafetyTrackTypeMap.ZEFR })
      .then(({ data = {} }) => {
        commit(types.SET_ZEFR_AUTHORITY, data?.has_authorization || false);
      }).catch(() => {});
  },
  async getBsIasAuthority({ commit }) { // 检查BS IAS授权
    await request.get(apis.creative.brandSafetyAuthority, { partner: BrandSafetyTrackTypeMap.IAS })
      .then(({ data = {} }) => {
        commit(types.SET_BSIAS_AUTHORITY, data?.has_authorization || false);
      }).catch(() => { });
  },
  async getBsDvAuthority({ commit }) { // 检查BS IAS授权
    await request.get(apis.creative.brandSafetyAuthority, { partner: BrandSafetyTrackTypeMap.DV })
      .then(({ data = {} }) => {
        commit(types.SET_BS_DV_AUTHORITY, data?.has_authorization || false);
      }).catch(() => { });
  },
  async getZefrSupportCountries({ commit }) { // 协议签署
    await request.get(
      apis.creative.bsThridPartySupportCountries,
      { brand_safety_postbid_partner: BrandSafetyTrackTypeMap.ZEFR },
    ).then(({ data = {} }) => {
      const countries = data?.country_ids.map(item => +item) || [];
      commit(types.SET_ZEFR_COUNTRY, countries);
    }).catch(() => { });
  },
  async getBsIasSupportCountries({ commit }, params) { // 协议签署
    await request.get(
      apis.creative.bsThridPartySupportCountries,
      { brand_safety_postbid_partner: BrandSafetyTrackTypeMap.IAS },
    ).then(({ data = {} }) => {
      const countries = data?.country_ids.map(item => +item) || [];
      commit(types.SET_BS_IAS_COUNTRY, countries);
    }).catch(() => { });
  },
  async getBsDvSupportCountries({ commit }, params) { // 协议签署
    await request.get(
      apis.creative.bsThridPartySupportCountries,
      { brand_safety_postbid_partner: BrandSafetyTrackTypeMap.DV },
    ).then(({ data = {} }) => {
      const countries = data?.country_ids.map(item => +item) || [];
      commit(types.SET_BS_DV_COUNTRY, countries);
    }).catch(() => { });
  },
  getCrmStatus(store, data) {
    return request.get(apis.creative.leadConnectorAuth, data);
  },
  /* ----------------------------------------------  单纯的api请求 end   ------------------------------------------------------------*/

  // 获取商品目录对应的动态词包列表
  async getDpaWordList({ commit }, platformId) {
    if (!platformId) {
      commit(types.SET_DPA_WORD_LIST, []);
      return [];
    }
    const url = apis.catalogue.lexicon(platformId);
    let list = [];
    try {
      const { data: resp = {} } = await request.get(url, { is_get_available_lexicon: true });
      list = resp.lexicons || [];
    } catch (err) {
      captureError(err);
    }
    commit(types.SET_DPA_WORD_LIST, list);
    return list;
  },
  async cloneByIndex({ state, dispatch }, { splitTestTab, index }) {
    const ad = state.ads[splitTestTab][index];
    const res = await dispatch('cloneAd', ad);
    return res;
  },
  cloneAd({ state, getters }, ad) {
    const target = _.cloneDeep(ad);
    const { adSource } = target;
    const { adType } = target[adSource];
    if (
      adType === SINGLE_VIDEO.value || adType === CATALOGUE_VIDEO.value
    ) {
      // 创意复制时清空 page id 避免重复
      // target[adSource][adType]?.page_id && (target[adSource][adType].page_id = '');
      // target[adSource][adType]?.card_id && (target[adSource][adType].card_id = '');

      const { product_set_id, product_platform_id } = target[adSource][adType];
      // 清除 additional creative前端增加使用的参数
      // for (const key of Object.keys(ADDITIONAL_CREATIVE_PARAMS)) {
      //   target[adSource][adType][key] = undefined;
      // }
      // shop ads的这2个字段不应该被清空，此处做恢复。（仅处理shopAds，其他的等productSet全量下沉后再调整）
      if (getters.isShop) {
        target[adSource][adType].product_set_id = product_set_id;
        target[adSource][adType].product_platform_id = product_platform_id;
      }
    }
    // 复制场景下如果有cta_id，就清空ctaid
    if (!_.isEmpty(target[adSource][adType].call_to_action_id)) {
      target[adSource][adType].call_to_action_id = '';
      // 在清除id的情况下，如果用户选的是自动优选，我们也要
      if (target[adSource][adType].call_to_action_type === ADVANCED_CREATIVE_TYPE.autoOptimized) {
        target[adSource][adType].call_to_action = '';
      }
    }
    return target;
  },
  // 复制一个ad
  async adFileCopy({
    state, getters, commit, dispatch,
  }, { splitTestTab, index }) {
    const target = await dispatch('cloneByIndex', {
      splitTestTab,
      index,
    });
    if (isAdEmpty(target)) {
      return false;
    }

    if (getters.isLastAdEmpty(splitTestTab)) {
      // 如果最后一个ad是空的，在点击其他ad的复制功能时，填充到最后一个ad
      commit(types.UPDATE_AD, {
        splitTestTab,
        ad: target,
        index: state.ads[splitTestTab].length - 1,
      });
    } else {
      commit(types.ADD_AD, { splitTestTab, ad: target });
    }
    return true;
  },
  // 增加一个ad
  async adFileAdd({
    state, commit, dispatch, getters,
  }, { splitTestTab, adDetail = {} }) {
    const clonedDetail = _.cloneDeep(adDetail);

    if (getters.isLastAdEmpty(splitTestTab)) {
      // 如果最后一个ad是空的，将素材信息填充到进去
      await dispatch('updateAdMaterial', {
        splitTestTab,
        adDetail: clonedDetail,
        index: state.ads[splitTestTab].length - 1,
      });
    } else {
      commit(types.ADD_AD_BY_DETAIL, { splitTestTab, adDetail: clonedDetail });
    }
  },

  // 更新创意的素材部分
  updateAdMaterial({ commit, state }, {
    splitTestTab, adDetail, index, adType,
  }) {
    const ad = _.cloneDeep(state.ads[splitTestTab][index]) || {};
    const { adSource } = ad;
    const sourceTarget = ad[adSource];

    if (!sourceTarget) {
      return;
    }

    const targetAdType = adType || sourceTarget.adType; // 优先使用指定的类型
    // 只有单图、单视频创意才有素材部分
    const hasMaterialAdType = [
      SINGLE_IMAGE.value,
      SINGLE_VIDEO.value,
      CAROUSEL_IMAGE.value,
    ];
    if (hasMaterialAdType.includes(targetAdType)) {
      sourceTarget[targetAdType] = {
        ...sourceTarget[targetAdType],
        ...adDetail,
      };
      commit(types.UPDATE_AD, { splitTestTab, ad, index });
    }
  },
  // 删除创意的素材信息
  clearAdMaterial({ commit, state }, { splitTestTab, index }) {
    const ad = _.cloneDeep(state.ads[splitTestTab][index]) || {};
    const { adSource } = ad;
    const sourceTarget = ad[adSource];
    if (!sourceTarget) {
      return;
    }
    const { adType } = sourceTarget; // 优先使用指定的类型
    if (!adType) {
      return;
    }

    const adDetail = sourceTarget[adType];
    const { identity_type = 0 } = adDetail;
    const isNativeAd = nativeAdIdentityTypes.includes(identity_type);
    if (!isNativeAd) {
      return;
    }
    if (adType !== REAL_TIME_LIVE.value) {
      /*
        live直投直播间更换identity_type的时候不清空image_mode
        否则creative/check接口报错
      */
      delete adDetail.image_mode;
    }
    adDetail.title = '';
    delete adDetail.aweme_item_id;
    delete adDetail.image_info;
    delete adDetail.video_info;
    commit(types.UPDATE_AD, { splitTestTab, ad, index });
  },
  // 删除一个ad
  adFileDelete({ commit, getters, state }, { splitTestTab, index, isOffsitePixel }) {
    if (state.ads[splitTestTab].length === 1) {
      const adType = getters.adTypeByIndex(splitTestTab, 0);
      const ad = getAdTemplateByType(getters.adSourceByIndex(splitTestTab, 0), getters.adTypeByIndex(splitTestTab, 0));
      const { adSource } = ad;
      const originAdDetail = state.ads[splitTestTab][0][adSource][adType] || {};
      ad[adSource][adType].action_track_url = originAdDetail.action_track_url;
      ad[adSource][adType].track_url = originAdDetail.track_url;

      // 如果支持CTA优选，删除最后一个素材，清空数据，则默认选中自定义CTA
      ad[adSource][adType].call_to_action_type = ADVANCED_CREATIVE_TYPE.customization;

      if (isOffsitePixel) { // offsite pixelinstant page checkbox不可编辑
        const isInstantPageChecked = originAdDetail.cardAdditionalInfo?.[ADDITION_INSTANT_PAGE]?.isChecked;
        if (ad[adSource][adType]?.cardAdditionalInfo) {
          ad[adSource][adType].cardAdditionalInfo[ADDITION_INSTANT_PAGE].isChecked = isInstantPageChecked;
        }
      }
      // 如果是shop ads且是仅剩的一个ad被删除，新的ad需要保留原有的identity、page_id、product_platform_id
      // shop下被删除以后，保留原来的creative_type,还有一些权限判断字段
      if (getters.isShop) {
        const identityData = getters.adIdentityDataByIndex(splitTestTab, 0);
        const {
          page_id, product_platform_id, creative_type, creative_shop_id,
          copy_from_ad_id, copy_creative_shop_id, product_selection_type,
        } = originAdDetail;
        Object.assign(ad[adSource][adType], {
          identity_data: identityData,
          identity_bc_id: identityData?.identity_bc_id,
          identity_id: identityData?.identity_id,
          identity_type: identityData?.identity_type,
          can_use_live_list: identityData?.can_use_live_list,
          can_use_video_list: identityData?.can_use_video_list,
          available_status: identityData?.available_status,
          creative_type,
          page_id,
          product_platform_id,
          creative_shop_id,
          call_to_action: getters.isShopLive ? SHOP_LIVE_CTA.id : SHOP_NOW_CTA.id,
          copy_from_ad_id,
          copy_creative_shop_id,
          product_selection_type,
        });
      }
      // 延续最后一个ad的类型
      commit(types.UPDATE_AD, { // 最后一个ad不清空track
        splitTestTab,
        ad,
        index: 0,
      });
    } else {
      commit(types.DELETE_AD, { splitTestTab, index });
    }
  },
  // 设置ad的视频默认封面
  saveVideoDefaultCover({ dispatch, getters }, { splitTestTab, cover, index }) {
    const adType = SINGLE_VIDEO.value; // 只有单视频创意才需要设置封面
    const adDetail = _.cloneDeep(getters.adDetailByIndex(splitTestTab, index));
    adDetail.image_info = [cover];
    dispatch('updateAdMaterial', {
      splitTestTab,
      adDetail,
      index,
      adType,
    });
  },
  // 设置视频可选封面集
  saveVideoBackupCovers({ dispatch, getters }, { splitTestTab, covers = [], index }) {
    const adType = SINGLE_VIDEO.value; // 只有单视频创意才需要设置封面
    const adDetail = _.cloneDeep(getters.adDetailByIndex(splitTestTab, index));
    adDetail.video_info.covers = covers;

    dispatch('updateAdMaterial', {
      splitTestTab,
      adDetail,
      index,
      adType,
    });
  },

  saveDraft({ getters }, ads) {
    window.localStorage.setItem(getters.adStorageKey, JSON.stringify(ads));
  },

  loadDraft({ getters }) {
    const ads = localStorage.getItem(getters.adStorageKey);
    return (ads && ads !== 'undefined' && ads !== 'null') ? JSON.parse(ads) : null;
  },

  removeDraft({ getters }) {
    localStorage.removeItem(getters.adStorageKey);
  },

  removeAdData({ dispatch, commit }) {
    dispatch('removeDraft'); // 清理本地缓存
    dispatch('creative/playable-card-form/resetPlayable', null, { root: true }); // 重置试玩信息
    commit(types.RESET_ADS); // 重置创意素材
    commit(types.SET_APPINFO, {}); // 重置appinfo
  },

  // 获取ad下已实现创意列表
  async getCreatives({ commit, rootState }) {
    const ad_id = rootState.campaign.adgroup?.ad_id;
    const { creative_info = [] } = await service.getAdList({
      ad_id,
    });
    commit(types.SET_CREATIVES, creative_info);
  },

  // 获取素材列表信息并设置到vuex
  async getAdList({ dispatch }, adGroupData) {
    try {
      // const { data: resp } = await request.get(apis.creative.list, adGroupData);

      let listData = {};
      // 在白名单内的使用新接口
      if (isNewCreativeListWhite()) {
        listData = await request.get(apis.creative.new_list, adGroupData);
      } else {
        listData = await request.get(apis.creative.list, adGroupData);
      }
      const resp = listData.data || {};
      const adDetailList = (resp.creative_info || []).map(item => fillCreativeInfo(item)).map(item => ({
        ...item,
        copy_from_ad_id: adGroupData.ad_id,
      }));

      dispatch('setAdsAndPlayable', {
        adDetailList,
        playableUrl: [resp.playable_url],
      });

      // 根据白名单判断是否对identity账号权限做判断
      if (isCreativeHasIdentityWhite()) {
        dispatch('setAdsIdentityDataList', adDetailList);
      }
      return true;
    } catch (e) {
      return false;
    }
  },
  /**
   * 根据创意详情接口返回的数据回填到 vuex 【编辑和复制创意用到该函数】
   * @param {Object} param.creativeDetail 接口获取的创意数据
   * @param {Function} param.callback 存储之前对数据进行修改
   */
  async setAdsByCreativeDetail({ commit, dispatch }, { creativeDetail = {}, callback }) {
    // 重置vuex中的一些状态 这一步操作是为了避免页面闪现 上一个创意detail的数据
    commit(types.SET_IDENTITY_AUTHORIZATION_STATE, identityAvailableStatus.Available);

    const { AUTO } = DPA_VIDEO_DISPLAY_MODE_TYPE;
    const { creative_info: creativeInfo } = creativeDetail;
    const image_mode = Number(Object.keys(creativeInfo)[0]);
    const oldAdDetail = creativeInfo[image_mode][0];
    const isNativeAd = Object.values(NATIVE_AD_ACTION_TYPE).includes(oldAdDetail.item_source);
    const [native_source, nativeAdActionType] = isNativeAd
      ? [NATIVE_VIDEO.value, oldAdDetail.item_source]
      : [CREATE_NEW.value, undefined];
    // 电商锚点需求，将anchors字段放入video_info中，编辑复制场景下的数据回填的数据格式和新建保持一致
    if (!_.isEmpty(oldAdDetail.anchors)) {
      _.set(oldAdDetail, 'video_info.anchors', oldAdDetail.anchors);
    }

    const adDetail = {
      copy_from_ad_id: creativeDetail.ad_id,
      image_material_ids: oldAdDetail.image_material_ids || [],
      external_url_material_ids: oldAdDetail.external_url_material_ids || [],
      external_urls: oldAdDetail.external_urls || [],
      video_tpl_name: oldAdDetail.video_tpl_name || '',
      video_display_mode: oldAdDetail.video_display_mode || AUTO,
      creative_id: oldAdDetail.creative_id,
      image_info: oldAdDetail.image_info,
      title: oldAdDetail.title,
      creative_name: oldAdDetail.creative_name || '',
      call_to_action: oldAdDetail.call_to_action,
      image_mode,
      nativeAdActionType,
      page_id: oldAdDetail.page_id || '',
      dpa_open_url_type: oldAdDetail.dpa_open_url_type || 0,
      params_type: oldAdDetail.params_type || 0,
      source: oldAdDetail.source,
      app_name: oldAdDetail.app_name,
      open_url: oldAdDetail.open_url,
      external_url: oldAdDetail.external_url,
      auto_open: oldAdDetail.auto_open,
      is_open_url: oldAdDetail.is_open_url,
      avatar_icon: oldAdDetail.avatar_icon,
      action_track_url: oldAdDetail.action_track_url,
      track_url: oldAdDetail.track_url,
      autoCreativeName: false,
      dpa_word_set: oldAdDetail.dpa_word_set || [],
      native_source,
      aweme_item_id: oldAdDetail.aweme_item_id, // 后端接口需要，前端展示不用
      vast_moat: oldAdDetail.vast_moat || 0,
      vast_double_verify: oldAdDetail.vast_double_verify || 0,
      vast_ias: oldAdDetail.vast_ias || false,
      vast_url: oldAdDetail.vast_url || '',
      fallback_type: oldAdDetail.fallback_type,
      titles: oldAdDetail.titles,
      is_creative_authorized: !!oldAdDetail.is_creative_authorized, // 创意素材授权
      creative_type: oldAdDetail.creative_type, // 创意类型，用于判断是否是 PLP/PDP 创意
      advanced_creative_type: oldAdDetail.advanced_creative_type, // CTA类型（普通CTA，CTA优选集合）
      call_to_action_id: oldAdDetail.call_to_action_id, // CTA 优选集合ID
      format_structure: oldAdDetail.format_structure, // 附加创意类型 0-自定义 1-collection ads
      card_id: oldAdDetail.card_id || oldAdDetail.gesture_id || oldAdDetail.painted_egg_id || '', // 附加创意id, card_id 收敛后所有的附加创意都是用这个字段
      brand_safety_postbid_partner: oldAdDetail.brand_safety_postbid_partner,
      brand_safety_vast_url: oldAdDetail.brand_safety_vast_url,
      product_selection_type: oldAdDetail.product_selection_type,
      spu_id: oldAdDetail.spu_id,
      spu_list: oldAdDetail.spu_list || [],
      selectedSpuMap: {}, // spu Map
      product_set_id: oldAdDetail.product_set_id,
      product_platform_id: oldAdDetail.product_platform_id,
      domain: oldAdDetail.domain || '',

      disclaimer_type: oldAdDetail.disclaimer_type,
      disclaimer_text: oldAdDetail.disclaimer_text,
      disclaimer_clickable_texts: oldAdDetail.disclaimer_clickable_texts,
      has_disclaimer: Boolean(oldAdDetail.disclaimer_type),
      catalog_language: oldAdDetail.catalog_language, // 创意选择的商品库语言

      dark_post_status: oldAdDetail.dark_post_status,
      bc_restrict_delivery: oldAdDetail.bc_restrict_delivery,
      is_use_product_anchor: Boolean(oldAdDetail.is_use_product_anchor), // shop是否使用锚点投放
      schema_type: oldAdDetail.schema_type,
    };

    // 原生广告 音乐资质授权相关字段
    if (oldAdDetail.item_source === NATIVE_VIDEO.value) {
      adDetail.with_promotional_music = oldAdDetail.with_promotional_music !== false; // 是否打开推广音乐开关
      adDetail.item_duet_disabled = oldAdDetail.item_duet_disabled || 0; // 是否开启合拍
      adDetail.item_stitch_disabled = oldAdDetail.item_stitch_disabled || 0; // 是否开启跟拍
    }

    adDetail.video_info = oldAdDetail.video_info;
    // 帖子头像
    if (oldAdDetail.video_info) {
      adDetail.video_info.avatar_icon = oldAdDetail.avatar_icon || {};
      adDetail.video_info.nick_name = oldAdDetail.nick_name || '';
    }

    // identity结构白名单的创意 有identity相关属性
    // 全量之后 这部分可在上面adDetail对象中直接赋值
    if (isCreativeHasIdentityWhite()) {
      adDetail.identity_type = oldAdDetail.identity_type;
      adDetail.identity_id = oldAdDetail.identity_id;
      adDetail.identity_data = {
        avatar_icon: oldAdDetail.identity_id ? oldAdDetail.avatar_icon : {},
        display_name: oldAdDetail.identity_id ? (oldAdDetail.source || oldAdDetail.app_name) : '',
        identity_type: oldAdDetail.identity_type,
        identity_id: oldAdDetail.identity_id,
      };
      if (bcIdentityTypesList.includes(oldAdDetail.identity_type)) {
        adDetail.identity_bc_id = oldAdDetail.identity_bc_id || '';
        adDetail.identity_data.identity_bc_id = oldAdDetail.identity_bc_id || '';
      }
    }

    /**
     * DPA创意: image_info固定是[]，没有video_info字段
     * 单图创意：image_info包含具体图片信息，没有video_info字段
     * 单视频创意：video_info和image_info都不为空
     * 注意：原生广告在identity账号授权不足的情况 同样也是 image_info固定是[]，没有video_info字段
    */
    if (Array.isArray(oldAdDetail.image_info) && oldAdDetail.image_info.length === 0) {
      adDetail.video_info = oldAdDetail.video_info || {};
      // 判断原生广告是否有视频信息
      const hasVideoInfo = Object.keys(adDetail.video_info).length;
      if (oldAdDetail.item_source === NATIVE_VIDEO.value && !hasVideoInfo) {
        delete adDetail.image_info;
        delete adDetail.video_info;
      }
    }
    callback && callback(adDetail);

    dispatch('setAdsAndPlayable', {
      adDetailList: [adDetail],
      playableUrl: [creativeDetail.playable_url],
    });
  },
  setAdsAndPlayable({ commit, dispatch }, { adDetailList = [], playableUrl = [] }) {
    commit(types.SET_ADS_BY_DETAIL, adDetailList); // 根据素材信息设置ad数组
    commit(types.UPDATE_SPLIT_TEST_TAB, 0);
    dispatch('creative/playable-card-form/openAndSetPlayableUrl', playableUrl, { root: true }); // 设置试玩信息
  },
  // 复制：只对identity账号的权限做处理
  async setAdsIdentityDataList({ commit, getters }, list) {
    const newList = await setIdentityDataList(list, getters.isShop);
    commit(types.SET_ADS_BY_DETAIL, newList); // 设置ad数组
  },
  async getAppInfo({ commit, dispatch }, params) {
    const { data } = await request.get(apis.creative.appInfo, params);
    commit(types.SET_APPINFO, data.app);
  },
  // 设置实时校验的校验状态
  setRealTimePrecheckSuggtions({ commit }, params) {
    commit(types.SET_REAL_TIME_PRECHECK_SUGGESTIONS, params);
  },
  // 删除某一个广告下的校验状态
  deleteRealTimePrecheckSugggtions({ commit }, params) {
    commit(types.DELETE_REAL_TIME_PRECHECK_SUGGESTIONS, params);
  },
  // 将实时校验的校验状态，放到素材预校验的vuex数据中
  setRealTimeSuggtionsIntoPrecheckSuggestions({ commit }, params) {
    commit(types.SET_PRECHECK_SUGGESTIONS, params.suggestions);
    commit(types.SET_PRECHECK_SUMMARY, params.summary);
  },
  async getPrecheckSuggestions({ commit }, params) {
    let suggestions = {};
    let summary = [];
    try {
      const { data = {} } = await request.post(apis.creative.precheck, params.param);
      // 处理一些原生以及推视频需要下掉的一些校验
      const data_ = filterPrecheckResult(data, params.verifyAdsParams);

      suggestions = data_.material_results || {};
      summary = data_.summary_results || [];
    } catch (err) {
      captureError(err);
    }
    commit(types.SET_PRECHECK_SUGGESTIONS, suggestions);
    commit(types.SET_PRECHECK_SUMMARY, summary);
    return summary;
  },
  clearPrecheckSuggestions({ commit }) {
    commit(types.SET_PRECHECK_SUGGESTIONS, []);
    commit(types.SET_PRECHECK_SUMMARY, []);
  },
  changePrecheckSuggestionsByIndex({ commit, state }, { changeType = 'delete', index = 0, value = {} }) {
    try {
      const suggestions = _.cloneDeep(state.precheckSuggestions);
      switch (changeType) {
        case 'delete': suggestions.splice(index, 1); break;
        case 'update': suggestions.splice(index, 1, value); break;
        default: return;
      }
      const summeryArray = suggestions.map(item => Object.keys(item).reduce((result, currentName) => {
        const newResult = result.concat(item[currentName].map(({ suggestion }) => suggestion));
        return newResult;
      }, []));
      const summery = _.flattenDeep(summeryArray, Infinity);
      commit(types.SET_PRECHECK_SUGGESTIONS, suggestions);
      commit(types.SET_PRECHECK_SUMMARY, summery);
    } catch (e) {
      commit(types.SET_PRECHECK_SUGGESTIONS, []);
      commit(types.SET_PRECHECK_SUMMARY, []);
    }
  },
  fixVideoPrecheckSuggestionsByIndex({ commit, state }, { index }) {
    try {
      const suggestions = _.cloneDeep(state.precheckSuggestions);
      const value = Object.assign({}, suggestions[index], { videos: [] });
      suggestions.splice(index, 1, value);
      const summeryArray = suggestions.map(item => Object.keys(item).reduce((result, currentName) => {
        const newResult = result.concat(item[currentName].map(({ suggestion }) => suggestion));
        return newResult;
      }, []));
      const summery = _.flattenDeep(summeryArray, Infinity);
      commit(types.SET_PRECHECK_SUGGESTIONS, suggestions);
      commit(types.SET_PRECHECK_SUMMARY, summery);
    } catch (e) {
      commit(types.SET_PRECHECK_SUGGESTIONS, []);
      commit(types.SET_PRECHECK_SUMMARY, []);
    }
  },
  async [types.GET_ADDITIONAL_CREATIVE_CARD_INFO]({ commit, state, getters }, {
    param,
    splitTestTab,
    index,
    shouldFetchChangeCardInfo,
    isNativePageAdGroup,
    isUpdateCardInfo,
  }) {
    if (shouldFetchChangeCardInfo) {
      commit(types.SET_LOADING_PROMOTION_DETAIL, true);
    }
    const data = await getAttachmentCreativeInfo(param);
    const adSource = getters.adSourceByIndex(splitTestTab, 0);
    const adType = getters.adTypeByIndex(splitTestTab, 0);
    const additionalCreativeInfo = state.ads[splitTestTab][index][adSource][adType].cardAdditionalInfo || {};
    const additionalCreativeCardInfo = additionalCreativeInfo[ADDITION_IMAGE_CARD];
    // 接口返回的content字段是JSON
    const {
      id: cardId, type: creativeType, title, need_destination,
    } = data;
    if (!cardId) {
      const errorMsg = `[creative] get cardId error cardInfo ${JSON.stringify(data)}`;
      sendLog('log', {
        level: 'info',
        value: errorMsg,
        type: 'get_card_info_failed',
      });
    }
    if (!title) {
      const errorMsg = `[creative] get title error :cardInfo ${JSON.stringify(data)}`;
      sendLog('log', {
        level: 'info',
        value: errorMsg,
        type: 'get_card_info_failed',
      });
    }
    if (!data?.card_infos?.thumbnail_uri) {
      const errorMsg = `[creative] get thumbnail_uri error :cardInfo ${JSON.stringify(data)}`;
      sendLog('log', {
        level: 'info',
        value: errorMsg,
        type: 'get_card_info_failed',
      });
    }
    if (need_destination === undefined) {
      const errorMsg = `[creative] get need_destination error :cardInfo ${JSON.stringify(data)}`;
      sendLog('log', {
        level: 'info',
        value: errorMsg,
        type: 'get_card_info_failed',
      });
    }
    let firstCard = {};
    let type = creativeType;
    // 如果是type 2 是卡片，包括图片卡和礼包码卡片
    if (type === 2) {
      const { card_infos = [] } = data;
      firstCard = card_infos?.[0] ?? {};
      // 如果是卡片真实的类型从card_infos 里面取
      type = firstCard?.type;
    } else {
      firstCard = { id: data?.id, type, ...data?.info ?? {} };
    }
    firstCard = { ...firstCard, title, need_destination };
    const isGameGiftCard = type === ADDITIONAL_CREATIVE_IMAGE_CARD_TEMPLATE_TYPES.GAME_GIFT_CARD.value;
    const isNotSupportCard = isGameGiftCard && isNativePageAdGroup;
    if (isNotSupportCard) return;
    const newCardInfo = Object.assign({}, additionalCreativeCardInfo, { mode: type, isChecked: Boolean(cardId) });
    // 附加创意信息从这获取，包括附加创意类型
    const value = Object.assign({}, additionalCreativeInfo, { [ADDITION_IMAGE_CARD]: newCardInfo });
    if (shouldFetchChangeCardInfo) {
      commit(types.CHANGE_AD_PROPERTY, {
        splitTestTab,
        index,
        prop: 'cardAdditionalInfo',
        value,
      });
      commit(types.SET_LOADING_PROMOTION_DETAIL, false);
    }
    if (isUpdateCardInfo) {
      commit(types.CHANGE_AD_PROPERTY, {
        splitTestTab,
        index,
        prop: 'cardAdditionalInfo',
        value,
      });
    }
    return Object.assign({}, data, { content: firstCard });
  },
  async [types.CREATE_ADDITION_CREATIVE_CUSTOMIZED_CARD]({ commit }, { param, splitTestTab, index }) {
    const res = await service.createAdditionalCreativeCustomizedImageCard(param);
    const data = res?.data;
    const card_id = data?.card_id;
    commit(types.CHANGE_AD_PROPERTY, {
      splitTestTab,
      index,
      prop: 'card_id',
      value: card_id,
    });
    return data;
  },
  // 创意这里getDomain
  async getDomain({ state, commit, getters }, params) {
    if (state.domainCancelToken) {
      state.domainCancelToken.cancel();
    }
    const cancelToken = request.axios.CancelToken;
    const source = cancelToken.source();
    commit(types.SET_CREATIVE_DOMAIN, source);
    // 多创意把index传进来
    const { url, index, splitTestTab } = params;
    try {
      const data = await service.getExternalUrlDomain({
        external_url: url,
      }, source.token);
      commit(types.SET_EXTERNAL_URL_DOMAIN, { index, domain: data.domain, splitTestTab });
      return data.domain || '';
    } catch (err) {
      captureError(err);
    }
  },
  /**
   * 重置创意层级数据中用不到的数据（主要处理的是创意=》adgroup=》创意这种来回跳的场景）
   */
  resetAllCreativeDataExtraKey({ commit, state, getters }, params) {
    const newAds = _.cloneDeep(state.ads) || [];
    newAds.forEach((ads = [], splitTestTab) => {
      const creativeDataList = [];
      ads.forEach((ad, adIndex) => {
        let creativeData = getters.adDetailByIndex(splitTestTab, adIndex);
        creativeData = resetCreativeExtraKey({
          creativeData,
          adgroupData: params.adgroup,
          isCopy: params.isCopy,
          isCreate: params.isCreate,
          shouldClearFallbackType: params.shouldClearFallbackType,
        });
        creativeDataList.push(creativeData);
      });
      commit(types.SET_ADS_BY_INDEX, { creativeDataList, splitTestTab });
    });
  },
  async [types.GET_ADDITIONAL_CREATIVE_PAGE_INFO]({ commit, state, getters }, {
    param, splitTestTab, index, shouldFetchChangePageInfo,
  }) {
    if (shouldFetchChangePageInfo) {
      commit(types.SET_LOADING_PROMOTION_DETAIL, true);
    }
    const res = await service.getAdditionalCreativePageInfo(param);
    const { page_content = {} } = res?.data || {};
    const { template_name } = page_content;
    const adSource = getters.adSourceByIndex(splitTestTab, 0);
    const adType = getters.adTypeByIndex(splitTestTab, 0);
    const additionalCreativeInfo = state.ads[splitTestTab][index][adSource][adType].cardAdditionalInfo || {};
    const additionalCreativePageInfo = additionalCreativeInfo[ADDITION_INSTANT_PAGE];
    const newPageInfo = Object.assign({}, additionalCreativePageInfo, { template_name, isChecked: Boolean(param.page_id) });
    const value = Object.assign({}, additionalCreativeInfo, { [ADDITION_INSTANT_PAGE]: newPageInfo });
    if (shouldFetchChangePageInfo) {
      commit(types.CHANGE_AD_PROPERTY, {
        splitTestTab,
        index,
        prop: 'cardAdditionalInfo',
        value,
      });
      commit(types.SET_LOADING_PROMOTION_DETAIL, false);
    }
    return page_content;
  },
  // 这个用不到了
  async [types.GET_ADDITIONAL_CREATIVE_ENGAGEMENT_INFO]({ commit, state, getters }, {
    param, splitTestTab, index, type,
  }) {
    if (![EGG.value, GESTURE.value].includes(type) || !param.creative_id) return;
    commit(types.SET_LOADING_PROMOTION_DETAIL, true);
    const res = await getEngagementCreativeInfo(param);
    const previewUrl = res?.info?.thumbnail_uri;
    const adSource = getters.adSourceByIndex(splitTestTab, index);
    const adType = getters.adTypeByIndex(splitTestTab, index);
    const additionalCreativeInfo = state.ads[splitTestTab][index][adSource][adType].cardAdditionalInfo || {};
    const engagementInfo = additionalCreativeInfo[ADDITION_ENGAGEMENT];
    const isEgg = type === EGG.value;
    const newInfo = Object.assign({}, engagementInfo, { previewUrl, isChecked: Boolean(param), mode: isEgg ? EGG.value : GESTURE.value });
    const value = Object.assign({}, additionalCreativeInfo, { [ADDITION_ENGAGEMENT]: newInfo });
    commit(types.CHANGE_AD_PROPERTY, {
      splitTestTab,
      index,
      prop: 'cardAdditionalInfo',
      value,
    });
    commit(types.SET_LOADING_PROMOTION_DETAIL, false);
    return {
      previewUrl,
    };
  },
  // 获取当前user绑定的TTBA账号信息
  async getBindTTBAData({ commit, getters }, params) {
    const res = await service.getIdentityListV2({
      identity_type_list: [identityTypeMap.TT_USER],
    });

    if (res && res.data) {
      const { identity_list = [] } = res.data;
      const bindData = identity_list.find(item => item.identity_type === identityTypeMap.TT_USER) || {};
      commit(types.SET_BIND_ACCOUNT_DATA, bindData);
      if (params) {
        // 如果当前创意所选择的identity账号正是绑定的TTBA账号的话 记录TTBA账号的权限状态
        const { splitTestTab, index } = params;
        const adDetail = _.cloneDeep(getters.adDetailByIndex(splitTestTab, index));
        const { identity_type, identity_id } = adDetail;
        if (Object.keys(bindData).length) {
          if (identity_type === identityTypeMap.TT_USER && identity_id === bindData.identity_id) {
            commit(types.SET_IDENTITY_AUTHORIZATION_STATE, bindData.available_status);
          }
        }
      }
    }
  },
  // 对identity相关字段进行权限判断处理 之后回填到vuex
  async setAdDetailByIdentity({ commit, getters, dispatch }, {
    splitTestTab = 0, adIndex = 0, isEdit = false, isCopy = false,
  }) {
    const adDetail = getters.adDetailByIndex(splitTestTab, adIndex);
    if (_.isEmpty(adDetail)) return;

    const { adDetail: newDetail = {}, availableStatus } = await setIdentityData(adDetail, isEdit, getters.isShop);
    // 避免覆盖detail的其他字段
    if (_.has(newDetail, 'identity_id')) {
      const changeFieldlist = ['identity_id', 'identity_type', 'identity_data', 'identity_bc_id'];
      changeFieldlist.forEach((item) => {
        commit(types.CHANGE_AD_PROPERTY, {
          splitTestTab,
          index: adIndex,
          prop: item,
          value: newDetail[item],
        });
      });
    }
    if ((isEdit || isCopy) && typeof availableStatus === 'number') {
      commit(types.SET_IDENTITY_AUTHORIZATION_STATE, availableStatus);
    }
  },

  async [types.CHANGE_ADS_RENDER_TASK]({ dispatch, state }, {
    splitTestTab, index, taskList,
  }) {
    for (let i = 0; i < taskList.length; i++) {
      const task = taskList[i];
      const {
        taskActionType, taskId, call_to_action, title,
      } = task;
      const addNew = taskActionType === VIDEO_ASYNC_RENDER_FILL_ACTION_TYPE.ADD_NEW_CREATIVE;
      const adDetail = {
        video_info: {},
        image_info: [],
        taskId,
      };
      if (call_to_action) adDetail.call_to_action = call_to_action;
      if (call_to_action) adDetail.title = title;
      if (addNew) {
        const target = state.ads[splitTestTab][index];
        const { adSource } = target;
        const { adType } = target[adSource];
        const { identity_data, identity_id, identity_type } = target[adSource][adType];
        if (identity_data) adDetail.identity_data = identity_data;
        if (identity_id) adDetail.identity_id = identity_id;
        if (identity_type) adDetail.identity_type = identity_type;
        // eslint-disable-next-line no-await-in-loop
        await dispatch('adFileAdd', {
          splitTestTab,
          adDetail,
        });
      } else {
        // eslint-disable-next-line no-await-in-loop
        await dispatch('updateAdMaterial', {
          splitTestTab,
          adDetail,
          index,
        });
      }
    }
  },
  async [types.HANDLE_VIDEO_RENDER_ASYNCHRONOUS]({
    commit, state, getters, dispatch,
  }, {
    splitTestTab, index, taskList = [], recursion = false,
  }) {
    // 如果指定了adIndex，说明需要操作广告的taskId。
    const isNeedChangeAd = index !== undefined;
    if (isNeedChangeAd) {
      // 把taskId 回填到目标AD中，目标AD有可能是一个已存在的AD，有可能是一个需要新增的AD
      dispatch(types.CHANGE_ADS_RENDER_TASK, {
        splitTestTab, index, taskList,
      });
    }
    const isQuerying = getTaskList(state?.videoRenderInfoList[splitTestTab].taskList, RENDER_STATUS).length;
    // 把UID列表放入任务池中
    commit(types.SET_ADS_ASYNC_RENDER_VIDEO_TASK_IDS, { splitTestTab, taskList });
    // 是否有正在进行的一次查询，如果有，则只把UID存入任务池，等待下一次查询即可
    const task_list = getTaskList(state?.videoRenderInfoList[splitTestTab].taskList, RENDER_STATUS)
      .map(({ taskId }) => taskId);
    if ((isQuerying || !task_list.length) && !recursion) return;
    // 开启查询
    // 查询结果
    const renderResult = await fetchVideoRenderResultsByTaskIdsBatch({ task_list }) || {};
    const isResultError = !Object.keys(renderResult).length;
    // 服务异常则打断
    if (isResultError) {
      return;
    }
    const allInfoList = state.videoRenderInfoList[splitTestTab].taskList;
    // 最新的任务状态
    const taskListProcessed = allInfoList.map((task) => {
      if (renderResult[task.taskId]) {
        return {
          ...task,
          ...renderResult[task.taskId],
          status: renderResult[task.taskId].status,
          percentage: getTaskRenderPercentageByStatus(renderResult[task.taskId].status, task.percentage),
          renderStatus: getTaskRenderStatus(renderResult[task.taskId].status),
        };
      }
      return task;
    });
    // 找到本次查询新的已完成任务
    const videoRenderDoneResultList = Object.keys(renderResult)
      .map(taskId => ({ ...renderResult[taskId], taskId }))
      .filter(({ status }) => getIsAsyncRenderVideoRenderDone(status))
      .map(({ taskId }) => taskListProcessed.find(item => item.task_id === taskId));
    if (!videoRenderDoneResultList.length) {
      sendLog('counter', {
        name: 'quick_optimize',
        value: 1,
        type: 'quick_optimize_error',
      });
    }
    sendLog('counter', {
      name: 'quick_optimize',
      value: 1,
      tags: {
        type: 'quick_optimize',
      },
    });
    // 视频回填
    videoRenderDoneResultList.length
      && await dispatch(types.BATCH_FILL_VIDEO_INFO_BY_TASK_IDS, { splitTestTab, index, videoRenderDoneResultList });
    // 把最新结果同步到任务池
    commit(types.SET_ADS_ASYNC_RENDER_VIDEO_TASK_IDS, { splitTestTab, taskList: taskListProcessed });
    // 落库
    videoRenderDoneResultList.forEach((task) => {
      dispatch(types.SAVE_VIDEO_RENDER_TASK_RESULT_TO_LIBRARY_BY_ID, { taskId: task.taskId, splitTestTab });
    });
    // 任务池是否还有渲染中的任务
    const hasRenderingVideo = getTaskList(state?.videoRenderInfoList[splitTestTab].taskList, RENDER_STATUS)
      .length;
    // 如果任务池还有剩余任务 发起下一次查询
    if (hasRenderingVideo) dispatch(types.HANDLE_VIDEO_RENDER_ASYNCHRONOUS, { splitTestTab, index, recursion: true });
  },

  // 视频渲染结果落库
  async [types.SAVE_VIDEO_RENDER_TASK_RESULT_TO_LIBRARY_BY_ID]({ commit, state }, { taskId, splitTestTab }) {
    const targetTask = state.videoRenderInfoList?.[splitTestTab]?.taskList
      ?.find(task => task.taskId === taskId);
    if (!targetTask || getIsVideoRenderAllComplete(targetTask.status)) return;
    try {
      // 名称校验
      const { isCheckPass } = await fileNameCheck(targetTask.name);
      // 名称校验未通过
      if (!isCheckPass) {
        commit(types.CHANGE_VIDEO_RENDER_INFO_PROP, {
          splitTestTab,
          taskId,
          prop: 'status',
          value: VIDEO_ASYNC_RENDER_STATUS.RENDER_DONE_NAME_ERROR,
        });
        return;
      }
      const {
        name, tags: system_tags = [], businesses = [], vid,
      } = targetTask;
      // 尝试落库
      await service.videoToLibrary({
        vid,
        name,
        businesses,
        system_tags,
        status: 0,
      });
      // 落库后修改状态
      commit(types.CHANGE_VIDEO_RENDER_INFO_PROP, {
        splitTestTab,
        taskId,
        prop: 'status',
        value: VIDEO_ASYNC_RENDER_STATUS.RENDER_DONE_AND_CREATED,
      });
    } catch (e) {
      commit(types.CHANGE_VIDEO_RENDER_INFO_PROP, {
        splitTestTab,
        taskId,
        prop: 'status',
        value: VIDEO_ASYNC_RENDER_STATUS.RENDER_DONE_CREATED_FAILED,
      });
    }
  },
  [types.SAVE_VIDEO_FROM_FRONT_CREATIVE]({ commit }, task) {
    const {
      name, tags: system_tags = [], businesses = [], vid,
    } = task;
    if (!name || !vid) return;
    return service.videoToLibrary({
      vid,
      name,
      businesses,
      system_tags,
      status: 0,
    });
  },
  async [types.BATCH_FILL_VIDEO_INFO_BY_TASK_IDS]({ commit }, data) {
    // 批量回填渲染结果到创意
    const { splitTestTab, videoRenderDoneResultList = [] } = data;
    const videoFullInfoList = await getVideoFullInfoListByVideoRenderResultList(videoRenderDoneResultList);
    videoFullInfoList.forEach((videoFullInfo) => {
      commit(types.FILL_VIDEO_FULL_INFO_BY_TASK_ID, { splitTestTab, videoFullInfo });
    });
  },
  // 重新渲染视频任务
  async [types.RE_RENDER_CREATIVE_VIDEO]({ commit, dispatch, state }, { splitTestTab, task_id }) {
    // 发起重新渲染任务
    await service.reRenderCreativeVideo({ task_id });
    // 找到目标任务重置任务状态
    const targetTask = state.videoRenderInfoList?.[splitTestTab]?.taskList
      ?.find(({ taskId }) => taskId === task_id);
    if (targetTask) {
      const nextTryCount = targetTask.tryCount + 1;
      if (nextTryCount > VIDEO_RENDER_OPTIONS.SINGLE_VIDEO_RENDER_TRY_COUNT) return;
      const newTask = {
        ...targetTask,
        percentage: 0, // 重置进度
        status: VIDEO_ASYNC_RENDER_STATUS.RENDERING, // 重置状态
        tryCount: nextTryCount,
      };
      const taskList = [newTask];
      dispatch(types.HANDLE_VIDEO_RENDER_ASYNCHRONOUS, { splitTestTab, taskList });
    }
  },
  // 检查是否已创建过 Lead Ads 广告
  async checkHasLeadAds({ commit }) {
    const { data = {} } = await service.hasLeadAds();
    commit(types.CHECK_HAS_LEAD_ADS, data.is_exist);
  },
};
